require('./cardTransferMoneyToCheckingAccountStep1.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');

// @ commons
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
const { AmountInput } = require('commonsComponents/amountInput');
const { OKLink } = require('commonsComponents/OKLink');
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');

// @ utilities
const currencyHelper = require('utilities/currencyHelper');
const { FormattedText, formatText} = require('core/i18n').i18n;
const { validateAmount } = require('utilities/contactCenter/cardTransferMoneyToCheckingAccountHelper');

// @ constants
const { ENTER_KEY_CODE, EURO_TEXT } = require('constants/index');
const { COMMISSION_TABLE_URL, MINIMUM_TO_TRANSFER, MAXIMUM_TO_TRANSFER, AMOUNT_MULTIPLE_OF_NUMBER } = require('constants/contactCenter/cardTransferMoneyToCheckingAccount');

class CardTransferMoneyToCheckingAccountStep1 extends React.Component {

    constructor(props) {
        super(props);
        this.handleEnter = this.handleEnter.bind(this);
        const initialCommissionValue = {amount:0, currency: EURO_TEXT};

        this.state = {
            isError: false,
            errorMessage: '',
            commissionValue: currencyHelper.getFormattedString(initialCommissionValue),
            showedAmount: currencyHelper.getFormattedString(initialCommissionValue),
        };
    }

    componentWillReceiveProps(nextProps) {
        const { immStep, availableBalance, commissionPercentage } = this.props;
        const amount = nextProps.immStep.get('amount');
        const error = validateAmount( amount, availableBalance.currency, availableBalance.amount);

        if(immStep !== nextProps.immStep){
            this.setState({
                isError: !error.valid,
                errorMessage: error.validationMessage,
            });
        }
        this.setState({
            commissionValue: this.calculateCommission(amount, commissionPercentage, !error.valid, availableBalance.currency),
        });
    }

    calculateCommission(amount, percentage, isError, currency) {

        if(isError) {
            const initialCommissionValue = {amount:0, currency: EURO_TEXT};
            this.setState({
                showedAmount: currencyHelper.getFormattedString(initialCommissionValue),
            });
            return currencyHelper.getFormattedString(initialCommissionValue);
        }
        else {
            const amountCommission = {
                currency: currency,
                amount: amount * percentage / 100,
            };
            this.setState({
                showedAmount: currencyHelper.getFormattedString({amount: amount, currency: currency}),
            });
            return currencyHelper.getFormattedString(amountCommission);
        }
    }

    handleEnter(event) {
        const { availableBalance, onAmountChange, commissionPercentage } = this.props;
        const amount = Number.isNaN(parseFloat(event.target.value)) ? 0 : parseFloat(event.target.value);
        if(event.keyCode === ENTER_KEY_CODE) {
            onAmountChange(amount);
            const error = validateAmount(amount, availableBalance.currency, availableBalance.amount);
            this.setState({
                isError: !error.valid,
                errorMessage: error.validationMessage,
            });
            this.setState({
                commissionValue: this.calculateCommission(amount, commissionPercentage, !error.valid, availableBalance.currency),
            });
        }
    }

    render() {
        const { immStep, immCard, availableBalance, commissionPercentage, onAmountChange } = this.props;
        const formattedAvailableBalance = currencyHelper.getFormattedString(availableBalance);
        const amount = immStep.get('amount');
        const transferDataLabel = formatText('cardTransferMoneyToCheckingAccount-transferDataLabel');
        const transferConfirmation = formatText('cardTransferMoneyToCheckingAccount-transferConfirmationLabel');
        const availableBalanceLabel = formatText('cardTransferMoneyToCheckingAccount-availableBalanceLabel');
        const incomeAccountLabel = formatText('cardTransferMoneyToCheckingAccount-incomeAccountLabel');
        const commissionLabel = formatText('cardTransferMoneyToCheckingAccount-commissionLabel');
        const currency = currencyHelper.formatCurrency(availableBalance.currency);
        const ownerName = immCard.get('beneficiaryName');
        const showedAmount = this.state.showedAmount;
        const associatedAccount = immCard.get('associatedAccount');
        const cardAlias = immCard.getIn(['alias', 'current']);

        return (
            <div className="card-transfer-money-to-checking-account-step1">
                <h4 className="card-transfer-money-to-checking-account-step1__title wizard-step--vertical__title">{transferDataLabel}</h4>
                <div className="card-transfer-money-to-checking-account-step1__main-content">
                    <OKInformativeList columns={2}>
                        <OKInformativeListItem key={0} className="card-transfer-money-to-checking-account-step1__item" title={incomeAccountLabel}>
                            <div className="card-transfer-money-to-checking-account-step1__value">
                                {associatedAccount}
                            </div>
                        </OKInformativeListItem>
                        <OKInformativeListItem key={1} className="card-transfer-money-to-checking-account-step1__item no-print-out" title={availableBalanceLabel}>
                            <div className="card-transfer-money-to-checking-account-step1__value">
                                {formattedAvailableBalance}
                            </div>
                        </OKInformativeListItem>
                    </OKInformativeList>
                    <div className="row">
                        <div className="card-transfer-money-to-checking-account-step1__label-amount col-xs-2">
                            <FormattedText value="cardTransferMoneyToCheckingAccount-amountToTransfer"/>
                        </div>
                        <div className="card-transfer-money-to-checking-account-step1__input-amount col-xs-4">
                            <AmountInput
                                id="inp_CardTransferMoneyToCheckingAccountStep1_Amount"
                                callback={onAmountChange}
                                min={0}
                                showBlurZero
                                hideFocusZero
                                disablePaste
                                amount={amount}
                                error={this.state.isError}
                                errorMsg={this.state.errorMessage}
                                onKeyDown={this.handleEnter}
                            />
                            <span className="card-transfer-money-to-checking-account-step1__currency">
                                {currency}
                            </span>
                        </div>
                        <div className="card-transfer-money-to-checking-account__commission-label col-xs-5 no-print-out">
                            <FormattedText
                                value="cardTransferMoneyToCheckingAccount-commissionText"
                                injectedStrings={[commissionPercentage]}
                            />
                            <OKLink
                                to={COMMISSION_TABLE_URL}
                                modifier="widget"
                                target="_blank"
                            >
                                <FormattedText
                                    value="cardTransferMoneyToCheckingAccount-informationCommission"
                                />
                            </OKLink>
                        </div>
                    </div>
                    <OKInformativeList columns={1}>
                        <OKInformativeListItem key={0} className="card-transfer-money-to-checking-account-step1__item" title={commissionLabel}>
                            <div className="card-transfer-money-to-checking-account-step1__value">
                                {this.state.commissionValue}
                            </div>
                        </OKInformativeListItem>
                    </OKInformativeList>
                    <div className="row">
                        <span className="card-transfer-money-to-checking-account-step1__label-information col-xs-12 no-print-out">
                            {formatText('cardTransferMoneyToCheckingAccount-informationLabelImport')} <i className="icon-informacion"></i>
                        </span>
                    </div>
                    <div className="row">
                        <span className="card-transfer-money-to-checking-account-step1__label-information col-xs-12 no-print-out">
                            {formatText('cardTransferMoneyToCheckingAccount-informationLabelMinMax', [ MINIMUM_TO_TRANSFER, EURO_TEXT, MAXIMUM_TO_TRANSFER, EURO_TEXT, AMOUNT_MULTIPLE_OF_NUMBER, EURO_TEXT ])} <i className="icon-informacion"></i>
                        </span>
                    </div>
                    <h4 className="card-transfer-money-to-checking-account-step1__title no-print-out">
                        {transferConfirmation}
                    </h4>
                    <FormattedText
                        className="card-transfer-money-to-checking-account__commission-label col-xs-5 no-print-out"
                        value="cardTransferMoneyToCheckingAccount-operationRequestLabel"
                    />
                </div>
                <BlockInfo extraClass="card-transfer-money-to-checking-account-step1__block-info">
                    <p className="no-print-out">
                        {formatText('cardTransferMoneyToCheckingAccount-confirmationText1')}
                        <span className="card-transfer-money-to-checking-account-step1__bold-text">{ownerName}</span>
                    </p>
                    <p className="no-print-out">
                        {formatText('cardTransferMoneyToCheckingAccount-confirmationText2')}
                        <span className="card-transfer-money-to-checking-account-step1__bold-text">{showedAmount}</span>
                        {formatText('cardTransferMoneyToCheckingAccount-confirmationText3')}
                        <span className="card-transfer-money-to-checking-account-step1__bold-text">{cardAlias}</span>
                        {formatText('cardTransferMoneyToCheckingAccount-confirmationText4')}
                        <span className="card-transfer-money-to-checking-account-step1__bold-text">{associatedAccount}</span>
                    </p>
                    <p className="no-print-out">
                        <span className="card-transfer-money-to-checking-account-step1__bold-text">
                            {formatText('cardTransferMoneyToCheckingAccount-confirmationText5', [commissionPercentage])}
                        </span>
                    </p>
                    <p>
                        {formatText('cardTransferMoneyToCheckingAccount-confirmationText6')}
                        <span className="card-transfer-money-to-checking-account-step1__bold-text">{ownerName}</span>
                        {formatText('cardTransferMoneyToCheckingAccount-confirmationText7')}
                    </p>
                </BlockInfo>
            </div>
        );
    }
}

CardTransferMoneyToCheckingAccountStep1.propTypes = {
    immCard: PropTypes.object.isRequired,
    immStep: PropTypes.object.isRequired,
    availableBalance: PropTypes.object.isRequired,
    commissionPercentage: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    amountMultipleOfValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    minimumToTransfer: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    maximumToTransfer: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    onAmountChange: PropTypes.func.isRequired,
};

module.exports = CardTransferMoneyToCheckingAccountStep1;
